<template>
  <div>
    <base-page-title :titleText="pageTitle" />
    <b-col class="col-12 col-md-8 p-3 mx-auto">
      <b-card no-body class="p-3 mb-2">
        <validation-observer ref="accountForm" v-slot="{ valid, dirty }">
          <b-form>
            <b-row class="no-gutters">
              <b-col class="col-12 col-md-6 pr-md-1">
                <b-form-group
                  label-class="font-weight-bold"
                  :label="$t('firstName')"
                  label-for="firstName"
                >
                  <validation-provider
                    :name="$t('firstName')"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-input
                      id="firstName"
                      v-model="user.firstName"
                      :state="getValidationState(validationContext)"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="col-12 col-md-6 pl-md-1">
                <b-form-group
                  label-class="font-weight-bold"
                  :label="$t('lastName')"
                  label-for="lastName"
                >
                  <validation-provider
                    :name="$t('lastName')"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-input
                      id="lastName"
                      v-model="user.lastName"
                      :state="getValidationState(validationContext)"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="col-12 col-md-6 pr-md-1">
                <b-form-group
                  label-class="font-weight-bold"
                  :label="$t('email')"
                  label-for="email"
                >
                  {{ user.registration.email || "-" }}
                </b-form-group>
              </b-col>
              <b-col class="col-12 col-md-6 pl-md-1">
                <b-form-group
                  label-class="font-weight-bold"
                  :label="$t('phone')"
                  label-for="phone"
                >
                  <validation-provider
                    :name="$t('phone')"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-input
                      id="phone"
                      v-model="user.phone"
                      :state="getValidationState(validationContext)"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="col-12">
                <b-form-group
                  label-class="font-weight-bold"
                  :label="$t('position')"
                  label-for="position"
                >
                  <validation-provider
                    :name="$t('position')"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-input
                      id="position"
                      v-model="user.position"
                      :state="getValidationState(validationContext)"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="mt-3"></div>
            <b-row class="no-gutters justify-content-end">
              <b-col class="col-12 col-sm-auto">
                <b-button
                  :disabled="!valid || !dirty"
                  block
                  @click="updateEmployeeAccount"
                >
                  {{ $t("button.saveChanges") }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card>
    </b-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: "page.account.title",
      user: {}
    };
  },
  created() {
    this.user = { ...this.$store.getters["auth/getEmployeeAccount"] };
  },
  computed: {},
  methods: {
    getValidationState({ dirty, validated, valid = null, untouched }) {
      if (!untouched) return valid ? null : valid;
      else return null;
    },
    updateEmployeeAccount() {
      this.$store.commit("loader/SET_LOADER", {});
      this.$store.commit("auth/SET_EMPLOYEE_ACCOUNT", this.user);
      this.$store
        .dispatch("auth/updateEmployeeAccount")
        .catch(() => {})
        .finally(() => this.$store.dispatch("loader/close"));
    }
  }
};
</script>

<style scoped></style>
